'use strict';

var React = require('react');
var index = require('./index-d0d820c3.js');
var tslib = require('tslib');
require('events');
require('react/jsx-runtime');
require('@emotion/react');
require('react-intl');
require('react-dom');
require('react-hook-form');

const ButtonBase = (props) => {
    return (React.createElement(index.MultiThemeProvider, null,
        React.createElement(index.ButtonBase, Object.assign({}, props))));
};

const PDFIcon = (props) => {
    return (React.createElement(index.SvgIcon, Object.assign({}, props, { "data-testid": "pdfIcon" }),
        React.createElement("path", { d: 'M8.65 12.375H9.425V10.375H10.65C10.8667 10.375 11.05 10.304 11.2 ' +
                '10.162C11.35 10.0207 11.425 9.84167 11.425 9.625V8.375C11.425 ' +
                '8.15833 11.35 7.979 11.2 7.837C11.05 7.69567 10.8667 7.625 ' +
                '10.65 7.625H8.65V12.375ZM9.425 9.625V8.375H10.65V9.625H9.425ZM12.45 ' +
                '12.375H14.375C14.6083 12.375 14.796 12.304 14.938 12.162C15.0793 ' +
                '12.0207 15.15 11.8417 15.15 11.625V8.375C15.15 8.15833 15.0793 ' +
                '7.979 14.938 7.837C14.796 7.69567 14.6083 7.625 14.375 ' +
                '7.625H12.45V12.375ZM13.225 11.625V8.375H14.375V11.625H13.225ZM16.375 ' +
                '12.375H17.15V10.375H18.55V9.625H17.15V8.375H18.55V7.625H16.375V12.375ZM8.125 ' +
                '17C7.65833 17 7.271 16.846 6.963 16.538C6.65433 16.2293 6.5 15.8417 6.5 ' +
                '15.375V4.625C6.5 4.15833 6.65433 3.77067 6.963 3.462C7.271 3.154 7.65833 ' +
                '3 8.125 3H18.875C19.3417 3 19.7293 3.154 20.038 3.462C20.346 3.77067 20.5 ' +
                '4.15833 20.5 4.625V15.375C20.5 15.8417 20.346 16.2293 20.038 16.538C19.7293 ' +
                '16.846 19.3417 17 18.875 17H8.125ZM8.125 16H18.875C19.0417 16 19.1873 15.9373 ' +
                '19.312 15.812C19.4373 15.6873 19.5 15.5417 19.5 15.375V4.625C19.5 4.45833 ' +
                '19.4373 4.31267 19.312 4.188C19.1873 4.06267 19.0417 4 18.875 4H8.125C7.95833 ' +
                '4 7.81267 4.06267 7.688 4.188C7.56267 4.31267 7.5 4.45833 7.5 4.625V15.375C7.5 ' +
                '15.5417 7.56267 15.6873 7.688 15.812C7.81267 15.9373 7.95833 16 8.125 16ZM5.125 ' +
                '20C4.65833 20 4.27067 19.846 3.962 19.538C3.654 19.2293 3.5 18.8417 3.5 ' +
                '18.375V6.625H4.5V18.375C4.5 18.5417 4.56267 18.6873 4.688 18.812C4.81267 ' +
                '18.9373 4.95833 19 5.125 19H16.875V20H5.125Z' })));
};

const AddIcon = (props) => (React.createElement(index.SvgIcon, Object.assign({}, props, { "data-testid": "AddIcon" }),
    React.createElement("path", { d: 'M11.5 18.5V12.5H5.5V11.5H11.5V5.5H12.5V11.5H18.5V12.5H12.5V18.5H11.5Z' })));

const ExcelIcon = (props) => (React.createElement(index.SvgIcon, Object.assign({}, props, { "data-testid": 'excelIcon' }),
    React.createElement("g", { clipPath: 'url(#clip0_1985_562)' },
        React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M6 21.9048V19.3125H1.125C0.503679 19.3125 0 18.8088 0 18.1875V6.9375C0 6.31618 0.50368 ' +
                '5.8125 1.125 5.8125H6V2.09524C6 0.93807 6.92341 0 8.0625 0H18.5355C19.0786 0 19.5998 ' +
                '0.217598 19.9859 0.60556L23.3879 4.02377C23.7796 4.41734 24 4.95376 24 5.51345V21.9048C24 ' +
                '23.0619 23.0766 24 21.9375 24H8.0625C6.92341 24 6 23.0619 6 21.9048ZM7.3125 ' +
                '21.9048V19.3125H12.375C12.9963 19.3125 13.5 18.8088 13.5 18.1875V6.9375C13.5 ' +
                '6.31618 12.9963 5.8125 12.375 5.8125H7.3125V2.09524C7.3125 1.67445 7.64829 1.33333 ' +
                '8.0625 1.33333H18.2812V5.90476C18.2812 6.69374 18.9109 7.33333 19.6875 ' +
                '7.33333H22.6875V21.9048C22.6875 22.3256 22.3517 22.6667 21.9375 22.6667H8.0625C7.64829 ' +
                '22.6667 7.3125 22.3256 7.3125 21.9048ZM22.6875 5.51345V6H19.6875C19.6357 6 19.5938 ' +
                '5.95736 19.5938 5.90476V2.08691L22.4649 4.97175C22.6073 5.11487 22.6875 5.30993 ' +
                '22.6875 5.51345ZM16.0312 9.1875C15.6688 9.1875 15.375 9.48131 15.375 9.84375C15.375 ' +
                '10.2062 15.6688 10.5 16.0312 10.5H20.3438C20.7062 10.5 21 10.2062 21 9.84375C21 ' +
                '9.48131 20.7062 9.1875 20.3438 9.1875H16.0312ZM16.0312 12.1875C15.6688 12.1875 ' +
                '15.375 12.4813 15.375 12.8438C15.375 13.2062 15.6688 13.5 16.0312 13.5H20.3438C20.7062 ' +
                '13.5 21 13.2062 21 12.8438C21 12.4813 20.7062 12.1875 20.3438 12.1875H16.0312ZM15.375 ' +
                '15.8438C15.375 15.4813 15.6688 15.1875 16.0312 15.1875H20.3438C20.7062 15.1875 21 ' +
                '15.4813 21 15.8438C21 16.2062 20.7062 16.5 20.3438 16.5H16.0312C15.6688 16.5 15.375 ' +
                '16.2062 15.375 15.8438ZM5.85718 12.4065L3.75 16.3286H5.24194L6.61084 13.7292L7.97974 ' +
                '16.3286H9.48193L7.37476 12.4629L9.28711 8.8125H7.84644L6.63647 11.2273L5.40088 ' +
                '8.8125H3.94482L5.85718 12.4065Z' })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_1985_562" },
            React.createElement("rect", { width: "24", height: "24", fill: "white" })))));

const UploadIcon = (props) => {
    return (React.createElement(index.SvgIcon, Object.assign({}, props, { "data-testid": 'uploadIcon' }),
        React.createElement("path", { d: 'M6.61537 19.3462C6.15512 19.3462 5.77083 19.192 5.4625 ' +
                '18.8837C5.15417 18.5753 5 18.191 5 17.7308V15.3462H6V17.7308C6 ' +
                '17.8846 6.0641 18.0256 6.1923 18.1538C6.32052 18.282 6.46154 ' +
                '18.3462 6.61537 18.3462H17.3846C17.5385 18.3462 17.6795 ' +
                '18.282 17.8077 18.1538C17.9359 18.0256 18 17.8846 18 ' +
                '17.7308V15.3462H19V17.7308C19 18.191 18.8458 18.5753 ' +
                '18.5375 18.8837C18.2292 19.192 17.8449 19.3462 17.3846 ' +
                '19.3462H6.61537ZM11.5 15.5769V6.92692L9.16923 9.2577L8.46152 ' +
                '8.53848L12 5L15.5385 8.53848L14.8308 9.2577L12.5 6.92692V15.5769H11.5Z' })));
};

const ImageIcon = (props) => {
    return (React.createElement(index.SvgIcon, Object.assign({}, props, { "data-testid": "imageIcon" }),
        React.createElement("path", { d: 'M5.5 21C4.8 21 4.20833 20.7583 3.725 20.275C3.24167 19.7917 3 19.2 3 ' +
                '18.5V5.5C3 4.8 3.24167 4.20833 3.725 3.725C4.20833 3.24167 4.8 3 ' +
                '5.5 3H18.5C19.2 3 19.7917 3.24167 20.275 3.725C20.7583 4.20833 21 ' +
                '4.8 21 5.5V18.5C21 19.2 20.7583 19.7917 20.275 20.275C19.7917 20.7583 ' +
                '19.2 21 18.5 21H5.5ZM5.5 20H18.5C18.9167 20 19.2707 19.854 19.562 ' +
                '19.562C19.854 19.2707 20 18.9167 20 18.5V5.5C20 5.08333 19.854 ' +
                '4.72933 19.562 4.438C19.2707 4.146 18.9167 4 18.5 4H5.5C5.08333 ' +
                '4 4.72933 4.146 4.438 4.438C4.146 4.72933 4 5.08333 4 5.5V18.5C4 ' +
                '18.9167 4.146 19.2707 4.438 19.562C4.72933 19.854 5.08333 20 5.5 ' +
                '20ZM7.2 17L10 14.2L11.85 16.025L14 13.3L16.95 17H7.2ZM8.5 9.5C8.08333 ' +
                '9.5 7.72933 9.354 7.438 9.062C7.146 8.77067 7 8.41667 7 8C7 7.58333 ' +
                '7.146 7.22933 7.438 6.938C7.72933 6.646 8.08333 6.5 8.5 6.5C8.91667 ' +
                '6.5 9.27067 6.646 9.562 6.938C9.854 7.22933 10 7.58333 10 8C10 8.41667 ' +
                '9.854 8.77067 9.562 9.062C9.27067 9.354 8.91667 9.5 8.5 9.5Z' })));
};

const FileDescriptionIcon = (props) => {
    return (React.createElement(index.SvgIcon, Object.assign({}, props, { "data-testid": 'fileDescriptionIcon' }),
        React.createElement("path", { d: 'M8.5 17.5H15.5V16.5H8.5V17.5ZM8.5 13.5H15.5V12.5H8.5V13.5ZM6.61537 ' +
                '21C6.15512 21 5.77083 20.8458 5.4625 20.5375C5.15417 20.2292 5 ' +
                '19.8449 5 19.3846V4.61537C5 4.15512 5.15417 3.77083 5.4625 ' +
                '3.4625C5.77083 3.15417 6.15512 3 6.61537 3H14.5L19 7.5V19.3846C19 ' +
                '19.8449 18.8458 20.2292 18.5375 20.5375C18.2292 20.8458 17.8449 ' +
                '21 17.3846 21H6.61537ZM14 8V4H6.61537C6.46154 4 6.32052 4.0641 ' +
                '6.1923 4.1923C6.0641 4.32052 6 4.46154 6 4.61537V19.3846C6 ' +
                '19.5385 6.0641 19.6795 6.1923 19.8077C6.32052 19.9359 6.46154 ' +
                '20 6.61537 20H17.3846C17.5385 20 17.6795 19.9359 17.8077 ' +
                '19.8077C17.9359 19.6795 18 19.5385 18 19.3846V8H14Z' })));
};

const CSVIcon = (props) => {
    return (React.createElement(index.SvgIcon, Object.assign({}, props, { "data-testid": 'CSVIcon' }),
        React.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M5.4625 20.5375C5.77083 20.8458 6.15512 21 6.61537 21H17.3846C17.8449 21 ' +
                '18.2292 20.8458 18.5375 20.5375C18.8458 20.2292 19 19.8449 19 ' +
                '19.3846V17H20V11H19V7.5L14.5 3H6.61537C6.15512 3 5.77083 3.15417 ' +
                '5.4625 3.4625C5.15417 3.77083 5 4.15512 5 4.61537V11H4V17H5V19.3846C5 ' +
                '19.8449 5.15417 20.2292 5.4625 20.5375ZM18 11V8H14V4H6.61537C6.46154 ' +
                '4 6.32052 4.0641 6.1923 4.1923C6.0641 4.32052 6 4.46154 6 ' +
                '4.61537V11H18ZM6 17V19.3846C6 19.5385 6.0641 19.6795 6.1923 ' +
                '19.8077C6.32052 19.9359 6.46154 20 6.61537 20H17.3846C17.5385 20 ' +
                '17.6795 19.9359 17.8077 19.8077C17.9359 19.6795 18 19.5385 18 ' +
                '19.3846V17H6ZM9.74256 14.6506H8.95316C8.94773 14.8377 8.92513 ' +
                '14.982 8.88534 15.0835C8.84556 15.185 8.78407 15.2554 8.70088 ' +
                '15.2946C8.6195 15.3338 8.51189 15.3534 8.37806 15.3534C8.26232 ' +
                '15.3534 8.16647 15.3347 8.09051 15.2973C8.01637 15.2599 7.95759 ' +
                '15.2002 7.91419 15.1182C7.87078 15.0363 7.83914 14.9312 7.81924 ' +
                '14.8029C7.79935 14.6729 7.7894 14.5161 7.7894 14.3327V13.6673C7.7894 ' +
                '13.4803 7.80025 13.3218 7.82195 13.1917C7.84547 13.0617 7.88163 ' +
                '12.9566 7.93046 12.8764C7.97929 12.7963 8.04169 12.7384 8.11764 ' +
                '12.7027C8.1936 12.6653 8.28402 12.6466 8.38891 12.6466C8.52998 ' +
                '12.6466 8.64029 12.6689 8.71987 12.7134C8.79944 12.7562 8.85731 ' +
                '12.831 8.89348 12.9379C8.93146 13.043 8.95316 13.1882 8.95859 ' +
                '13.3734H9.7507C9.729 13.0795 9.6648 12.831 9.5581 12.6279C9.45321 ' +
                '12.4231 9.30401 12.2672 9.1105 12.1603C8.91699 12.0534 8.67646 12 ' +
                '8.38891 12C8.1737 12 7.9802 12.0365 7.80839 12.1096C7.63839 12.1808 ' +
                '7.49281 12.2877 7.37164 12.4302C7.25228 12.5709 7.16005 12.7455 7.09495 ' +
                '12.9539C7.03165 13.1623 7 13.4019 7 13.6727V14.3327C7 14.6034 7.02984 ' +
                '14.843 7.08952 15.0514C7.15101 15.2581 7.24143 15.4318 7.36079 ' +
                '15.5725C7.48015 15.7132 7.62483 15.8201 7.79483 15.8931C7.96482 ' +
                '15.9644 8.15924 16 8.37806 16C8.66019 16 8.90071 15.9483 9.09965 ' +
                '15.845C9.30039 15.7417 9.45501 15.5903 9.56352 15.3908C9.67203 15.1895 ' +
                '9.73171 14.9428 9.74256 14.6506ZM12.354 14.7335C12.3667 14.7905 12.373 ' +
                '14.8537 12.373 14.9232C12.373 15.0069 12.3594 15.0817 12.3323 ' +
                '15.1476C12.3052 15.2135 12.26 15.2661 12.1967 15.3053C12.1352 ' +
                '15.3445 12.052 15.3641 11.9471 15.3641C11.8549 15.3641 11.7726' +
                ' 15.3525 11.7002 15.3293C11.6297 15.3044 11.57 15.2679 11.5212 ' +
                '15.2198C11.4724 15.1699 11.4362 15.104 11.4127 15.022C11.3892 ' +
                '14.9383 11.3774 14.8377 11.3774 14.7201H10.5826C10.5826 14.941 ' +
                '10.6179 15.1325 10.6884 15.2946C10.7589 15.4549 10.8557 15.5876 ' +
                '10.9787 15.6927C11.1034 15.796 11.2472 15.8735 11.41 15.9252C11.5727 ' +
                '15.9751 11.7455 16 11.9281 16C12.1162 16 12.2862 15.9742 12.4381 ' +
                '15.9225C12.5918 15.8709 12.7229 15.7978 12.8314 15.7034C12.94 15.6072 ' +
                '13.0222 15.4932 13.0783 15.3614C13.1362 15.2278 13.1651 15.0799 ' +
                '13.1651 14.9178C13.1651 14.754 13.1416 14.6079 13.0946 14.4796C13.0476 ' +
                '14.3514 12.9779 14.2365 12.8857 14.1349C12.7935 14.0316 12.6786 13.939 ' +
                '12.5412 13.857C12.4037 13.7733 12.2455 13.6967 12.0665 13.6273C11.9742 ' +
                '13.5916 11.8892 13.5551 11.8115 13.5177C11.7355 13.4803 11.6695 13.442 ' +
                '11.6134 13.4028C11.5574 13.3618 11.5131 13.3164 11.4805 13.2665C11.4498 ' +
                '13.2149 11.4344 13.157 11.4344 13.0929C11.4344 13.0073 11.4498 12.9307 ' +
                '11.4805 12.8631C11.5131 12.7936 11.5619 12.7393 11.627 12.7001C11.6939 ' +
                '12.6591 11.778 12.6386 11.8793 12.6386C11.9878 12.6386 12.0764 12.6627 ' +
                '12.1451 12.7108C12.2139 12.7589 12.2636 12.8257 12.2943 12.9112C12.3269 ' +
                '12.9949 12.3432 13.092 12.3432 13.2024H13.1353C13.1353 12.969 13.0837 ' +
                '12.7624 12.9806 12.5825C12.8794 12.4026 12.7356 12.261 12.5493 ' +
                '12.1576C12.3649 12.0543 12.146 12.0027 11.8928 12.0027C11.7066 ' +
                '12.0027 11.5375 12.0285 11.3856 12.0802C11.2355 12.1318 11.1043 ' +
                '12.2057 10.9922 12.3019C10.8801 12.3963 10.7933 12.5104 10.7318 ' +
                '12.644C10.6721 12.7776 10.6423 12.9263 10.6423 13.0902C10.6423 ' +
                '13.2576 10.6739 13.4037 10.7372 13.5284C10.8023 13.6513 10.89 13.7582 ' +
                '11.0004 13.849C11.1107 13.9399 11.2346 14.02 11.372 14.0895C11.5094 14.1572 ' +
                '11.6514 14.2213 11.7979 14.2819C11.9209 14.3336 12.0203 14.3834 12.0963 ' +
                '14.4315C12.1741 14.4796 12.2328 14.5277 12.2726 14.5758C12.3142 14.6239 ' +
                '12.3414 14.6765 12.354 14.7335ZM15.0414 15.9466H15.2774H15.6219H15.8552L17 ' +
                '12.0561H16.1428L15.4471 14.899L14.7539 12.0561H13.9048L15.0414 15.9466Z' })));
};

const FolderOpenIcon = (props) => (React.createElement(index.SvgIcon, Object.assign({}, props, { "data-testid": 'folderOpenIcon' }),
    React.createElement("path", { d: 'M4.5 18.9999C4.0782 18.9999 3.72275 18.8554 3.43365 18.5663C3.14455 ' +
            '18.2772 3 17.9217 3 17.4999V7.38454C3 6.96276 3.16378 6.58808 ' +
            '3.49135 6.26051C3.8189 5.93295 4.19358 5.76917 4.61538 ' +
            '5.76917H10.7692L12 6.99994H19.3846C19.7295 6.99994 20.0305 ' +
            '7.09321 20.2875 7.27974C20.5446 7.46629 20.7244 7.70636 20.8269 ' +
            '7.99994H11.5981L10.3673 6.76917H4.61538C4.43589 6.76917 4.28846 ' +
            '6.82686 4.17308 6.94224C4.05769 7.05762 4 7.20506 4 7.38454V17.3846C4 ' +
            '17.5256 4.03526 17.641 4.10578 17.7307C4.17628 17.8204 4.26922 ' +
            '17.8974 4.38462 17.9615L6.76537 9.99994H22.9808L20.5981 17.9403C20.5032 ' +
            '18.2583 20.3215 18.5144 20.0529 18.7086C19.7843 18.9028 19.4846 ' +
            '18.9999 19.1539 18.9999H4.5ZM5.42692 17.9999H19.5385L21.6269 ' +
            '10.9999H7.51537L5.42692 17.9999Z' })));

const AddAPhotoIcon = (props) => {
    return (React.createElement(index.SvgIcon, Object.assign({}, props, { "data-testid": "AddAPhotoIcon" }),
        React.createElement("path", { d: 'M3.61538 20C3.15513 20 2.77083 19.8458 2.4625 19.5375C2.15417 19.2292 2 ' +
                '18.8449 2 18.3846V7.61538C2 7.15513 2.15417 6.77083 2.4625 6.4625C2.77083 ' +
                '6.15417 3.15513 6 3.61538 6H6.57308L8.42308 4H13.6154V5H8.85577L7.01155 ' +
                '7H3.61538C3.43589 7 3.28846 7.05769 3.17307 7.17307C3.05769 7.28846 3 ' +
                '7.43589 3 7.61538V18.3846C3 18.5641 3.05769 18.7115 3.17307 18.8269C3.28846 ' +
                '18.9423 3.43589 19 3.61538 19H18.3846C18.5641 19 18.7115 18.9423 18.8269 ' +
                '18.8269C18.9423 18.7115 19 18.5641 19 18.3846V10.3846H20V18.3846C20 18.8449 ' +
                '19.8458 19.2292 19.5375 19.5375C19.2292 19.8458 18.8449 20 18.3846 ' +
                '20H3.61538ZM19 7V5H17V4H19V2H20V4H22V5H20V7H19ZM11 16.7308C12.0449 16.7308 ' +
                '12.9279 16.3702 13.649 15.6491C14.3702 14.9279 14.7308 14.0449 14.7308 ' +
                '13C14.7308 11.9551 14.3702 11.0721 13.649 10.351C12.9279 9.6298 12.0449 ' +
                '9.26922 11 9.26922C9.95513 9.26922 9.07212 9.6298 8.35095 10.351C7.6298 ' +
                '11.0721 7.26923 11.9551 7.26923 13C7.26923 14.0449 7.6298 14.9279 8.35095 ' +
                '15.6491C9.07212 16.3702 9.95513 16.7308 11 16.7308ZM11 15.7308C10.2231 ' +
                '15.7308 9.57373 15.4699 9.05193 14.9481C8.53013 14.4263 8.26923 13.7769 ' +
                '8.26923 13C8.26923 12.2231 8.53013 11.5737 9.05193 11.0519C9.57373 ' +
                '10.5301 10.2231 10.2692 11 10.2692C11.7769 10.2692 12.4263 10.5301 ' +
                '12.9481 11.0519C13.4699 11.5737 13.7308 12.2231 13.7308 13C13.7308 13.7769 ' +
                '13.4699 14.4263 12.9481 14.9481C12.4263 15.4699 11.7769 15.7308 11 15.7308Z' })));
};

var COMMON_MIME_TYPES = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    ['aac', 'audio/aac'],
    ['abw', 'application/x-abiword'],
    ['arc', 'application/x-freearc'],
    ['avif', 'image/avif'],
    ['avi', 'video/x-msvideo'],
    ['azw', 'application/vnd.amazon.ebook'],
    ['bin', 'application/octet-stream'],
    ['bmp', 'image/bmp'],
    ['bz', 'application/x-bzip'],
    ['bz2', 'application/x-bzip2'],
    ['cda', 'application/x-cdf'],
    ['csh', 'application/x-csh'],
    ['css', 'text/css'],
    ['csv', 'text/csv'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    ['eot', 'application/vnd.ms-fontobject'],
    ['epub', 'application/epub+zip'],
    ['gz', 'application/gzip'],
    ['gif', 'image/gif'],
    ['heic', 'image/heic'],
    ['heif', 'image/heif'],
    ['htm', 'text/html'],
    ['html', 'text/html'],
    ['ico', 'image/vnd.microsoft.icon'],
    ['ics', 'text/calendar'],
    ['jar', 'application/java-archive'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['js', 'text/javascript'],
    ['json', 'application/json'],
    ['jsonld', 'application/ld+json'],
    ['mid', 'audio/midi'],
    ['midi', 'audio/midi'],
    ['mjs', 'text/javascript'],
    ['mp3', 'audio/mpeg'],
    ['mp4', 'video/mp4'],
    ['mpeg', 'video/mpeg'],
    ['mpkg', 'application/vnd.apple.installer+xml'],
    ['odp', 'application/vnd.oasis.opendocument.presentation'],
    ['ods', 'application/vnd.oasis.opendocument.spreadsheet'],
    ['odt', 'application/vnd.oasis.opendocument.text'],
    ['oga', 'audio/ogg'],
    ['ogv', 'video/ogg'],
    ['ogx', 'application/ogg'],
    ['opus', 'audio/opus'],
    ['otf', 'font/otf'],
    ['png', 'image/png'],
    ['pdf', 'application/pdf'],
    ['php', 'application/x-httpd-php'],
    ['ppt', 'application/vnd.ms-powerpoint'],
    ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
    ['rar', 'application/vnd.rar'],
    ['rtf', 'application/rtf'],
    ['sh', 'application/x-sh'],
    ['svg', 'image/svg+xml'],
    ['swf', 'application/x-shockwave-flash'],
    ['tar', 'application/x-tar'],
    ['tif', 'image/tiff'],
    ['tiff', 'image/tiff'],
    ['ts', 'video/mp2t'],
    ['ttf', 'font/ttf'],
    ['txt', 'text/plain'],
    ['vsd', 'application/vnd.visio'],
    ['wav', 'audio/wav'],
    ['weba', 'audio/webm'],
    ['webm', 'video/webm'],
    ['webp', 'image/webp'],
    ['woff', 'font/woff'],
    ['woff2', 'font/woff2'],
    ['xhtml', 'application/xhtml+xml'],
    ['xls', 'application/vnd.ms-excel'],
    ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    ['xml', 'application/xml'],
    ['xul', 'application/vnd.mozilla.xul+xml'],
    ['zip', 'application/zip'],
    ['7z', 'application/x-7z-compressed'],
    // Others
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['msg', 'application/vnd.ms-outlook']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                // If <input webkitdirectory> is set,
                // the File will have a {webkitRelativePath} property
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}

var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 *
 * EXPERIMENTAL: A list of https://developer.mozilla.org/en-US/docs/Web/API/FileSystemHandle objects can also be passed as an arg
 * and a list of File objects will be returned.
 *
 * @param evt
 */
function fromEvent(evt) {
    return tslib.__awaiter(this, void 0, void 0, function () {
        return tslib.__generator(this, function (_a) {
            if (isObject(evt) && isDataTransfer(evt.dataTransfer)) {
                return [2 /*return*/, getDataTransferFiles(evt.dataTransfer, evt.type)];
            }
            else if (isChangeEvt(evt)) {
                return [2 /*return*/, getInputFiles(evt)];
            }
            else if (Array.isArray(evt) && evt.every(function (item) { return 'getFile' in item && typeof item.getFile === 'function'; })) {
                return [2 /*return*/, getFsHandleFiles(evt)];
            }
            return [2 /*return*/, []];
        });
    });
}
function isDataTransfer(value) {
    return isObject(value);
}
function isChangeEvt(value) {
    return isObject(value) && isObject(value.target);
}
function isObject(v) {
    return typeof v === 'object' && v !== null;
}
function getInputFiles(evt) {
    return fromList(evt.target.files).map(function (file) { return toFileWithPath(file); });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function getFsHandleFiles(handles) {
    return tslib.__awaiter(this, void 0, void 0, function () {
        var files;
        return tslib.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(handles.map(function (h) { return h.getFile(); }))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, files.map(function (file) { return toFileWithPath(file); })];
            }
        });
    });
}
function getDataTransferFiles(dt, type) {
    return tslib.__awaiter(this, void 0, void 0, function () {
        var items, files;
        return tslib.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dt.items) return [3 /*break*/, 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') {
                        return [2 /*return*/, items];
                    }
                    return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, noIgnoredFiles(flatten(files))];
                case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return toFileWithPath(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    if (items === null) {
        return [];
    }
    var files = [];
    // tslint:disable: prefer-for-of
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return tslib.__spreadArray(tslib.__spreadArray([], tslib.__read(acc), false), tslib.__read((Array.isArray(files) ? flatten(files) : [files])), false); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject("".concat(item, " is not a File"));
    }
    var fwp = toFileWithPath(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return tslib.__awaiter(this, void 0, void 0, function () {
        return tslib.__generator(this, function (_a) {
            return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function (batch) { return tslib.__awaiter(_this, void 0, void 0, function () {
                var files, err_1, items;
                return tslib.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            // Continue reading
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return tslib.__awaiter(this, void 0, void 0, function () {
        return tslib.__generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = toFileWithPath(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}

var _default = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};

function _toConsumableArray$1(arr) { return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1(); }

function _nonIterableSpread$1() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray$1(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles$1(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$1(arr); }

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1(); }

function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$1(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }

var FILE_INVALID_TYPE = "file-invalid-type";
var FILE_TOO_LARGE = "file-too-large";
var FILE_TOO_SMALL = "file-too-small";
var TOO_MANY_FILES = "too-many-files";

var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: "Too many files"
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted

function fileAccepted(file, accept) {
  var isAcceptable = file.type === "application/x-moz-file" || _default(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }

  return [true, null];
}

function isDefined(value) {
  return value !== undefined && value !== null;
}
/**
 *
 * @param {object} options
 * @param {File[]} options.files
 * @param {string|string[]} [options.accept]
 * @param {number} [options.minSize]
 * @param {number} [options.maxSize]
 * @param {boolean} [options.multiple]
 * @param {number} [options.maxFiles]
 * @param {(f: File) => FileError|FileError[]|null} [options.validator]
 * @returns
 */


function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple,
      maxFiles = _ref.maxFiles,
      validator = _ref.validator;

  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }

  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray$1(_fileAccepted, 1),
        accepted = _fileAccepted2[0];

    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray$1(_fileMatchSize, 1),
        sizeMatch = _fileMatchSize2[0];

    var customErrors = validator ? validator(file) : null;
    return accepted && sizeMatch && !customErrors;
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === "function") {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== "undefined") {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === "Files" || type === "application/x-moz-file";
  });
}

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf("Edge/") !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}
/**
 * canUseFileSystemAccessAPI checks if the [File System Access API](https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API)
 * is supported by the browser.
 * @returns {boolean}
 */

function canUseFileSystemAccessAPI() {
  return "showOpenFilePicker" in window;
}
/**
 * Convert the `{accept}` dropzone prop to the
 * `{types}` option for https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
 *
 * @param {AcceptProp} accept
 * @returns {{accept: string[]}[]}
 */

function pickerOptionsFromAccept(accept) {
  if (isDefined(accept)) {
    var acceptForPicker = Object.entries(accept).filter(function (_ref2) {
      var _ref3 = _slicedToArray$1(_ref2, 2),
          mimeType = _ref3[0],
          ext = _ref3[1];

      var ok = true;

      if (!isMIMEType(mimeType)) {
        console.warn("Skipped \"".concat(mimeType, "\" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types."));
        ok = false;
      }

      if (!Array.isArray(ext) || !ext.every(isExt)) {
        console.warn("Skipped \"".concat(mimeType, "\" because an invalid file extension was provided."));
        ok = false;
      }

      return ok;
    }).reduce(function (agg, _ref4) {
      var _ref5 = _slicedToArray$1(_ref4, 2),
          mimeType = _ref5[0],
          ext = _ref5[1];

      return _objectSpread$1(_objectSpread$1({}, agg), {}, _defineProperty$1({}, mimeType, ext));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: acceptForPicker
    }];
  }

  return accept;
}
/**
 * Convert the `{accept}` dropzone prop to an array of MIME types/extensions.
 * @param {AcceptProp} accept
 * @returns {string}
 */

function acceptPropAsAcceptAttr(accept) {
  if (isDefined(accept)) {
    return Object.entries(accept).reduce(function (a, _ref6) {
      var _ref7 = _slicedToArray$1(_ref6, 2),
          mimeType = _ref7[0],
          ext = _ref7[1];

      return [].concat(_toConsumableArray$1(a), [mimeType], _toConsumableArray$1(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function (v) {
      return isMIMEType(v) || isExt(v);
    }).join(",");
  }

  return undefined;
}
/**
 * Check if v is an exception caused by aborting a request (e.g window.showOpenFilePicker()).
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is an abort exception.
 */

function isAbort(v) {
  return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
/**
 * Check if v is a security error.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/DOMException.
 * @param {any} v
 * @returns {boolean} True if v is a security error.
 */

function isSecurityError(v) {
  return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
/**
 * Check if v is a MIME type string.
 *
 * See accepted format: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers.
 *
 * @param {string} v
 */

function isMIMEType(v) {
  return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
/**
 * Check if v is a file extension.
 * @param {string} v
 */

function isExt(v) {
  return /^.*\.[\w]+$/.test(v);
}
/**
 * @typedef {Object.<string, string[]>} AcceptProp
 */

/**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */

/**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */

var _excluded = ["children"],
    _excluded2 = ["open"],
    _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"],
    _excluded4 = ["refKey", "onChange", "onClick"];

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties(_ref, _excluded);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties(_useDropzone, _excluded2);

  React.useImperativeHandle(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return /*#__PURE__*/React.createElement(React.Fragment, null, children(_objectSpread(_objectSpread({}, props), {}, {
    open: open
  })));
});
Dropzone.displayName = "Dropzone"; // Add default props for react-docgen

var defaultProps$1 = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: true,
  autoFocus: false
};
Dropzone.defaultProps = defaultProps$1;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: index.PropTypes.func,

  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: index.PropTypes.objectOf(index.PropTypes.arrayOf(index.PropTypes.string)),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: index.PropTypes.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: index.PropTypes.bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: index.PropTypes.bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: index.PropTypes.bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: index.PropTypes.bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: index.PropTypes.bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: index.PropTypes.number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: index.PropTypes.number,

  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: index.PropTypes.number,

  /**
   * Enable/disable the dropzone
   */
  disabled: index.PropTypes.bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: index.PropTypes.func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: index.PropTypes.func,

  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: index.PropTypes.func,

  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: index.PropTypes.bool,

  /**
   * Set to true to focus the root element on render
   */
  autoFocus: index.PropTypes.bool,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: index.PropTypes.func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: index.PropTypes.func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: index.PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: index.PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: index.PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: index.PropTypes.func,

  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: index.PropTypes.func,

  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: index.PropTypes.func
};
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

/**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  acceptedFiles: [],
  fileRejections: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {import("./utils").AcceptProp} [props.accept] Set accepted file types.
 * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {boolean} [props.useFsAccessApi] Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
 * to open the file picker instead of using an `<input type="file">` click event.
 * @param {boolean} autoFocus Set to true to auto focus the root element.
 * @param {Function} [props.onFileDialogOpen] Cb for when opening the file dialog
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be an object with keys as a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) and the value an array of file extensions (optional).
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 * @param {(error: Error) => void} [props.onError]
 *
 * @returns {DropzoneState & DropzoneMethods}
 */

function useDropzone() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps$1), props),
      accept = _defaultProps$props.accept,
      disabled = _defaultProps$props.disabled,
      getFilesFromEvent = _defaultProps$props.getFilesFromEvent,
      maxSize = _defaultProps$props.maxSize,
      minSize = _defaultProps$props.minSize,
      multiple = _defaultProps$props.multiple,
      maxFiles = _defaultProps$props.maxFiles,
      onDragEnter = _defaultProps$props.onDragEnter,
      onDragLeave = _defaultProps$props.onDragLeave,
      onDragOver = _defaultProps$props.onDragOver,
      onDrop = _defaultProps$props.onDrop,
      onDropAccepted = _defaultProps$props.onDropAccepted,
      onDropRejected = _defaultProps$props.onDropRejected,
      onFileDialogCancel = _defaultProps$props.onFileDialogCancel,
      onFileDialogOpen = _defaultProps$props.onFileDialogOpen,
      useFsAccessApi = _defaultProps$props.useFsAccessApi,
      autoFocus = _defaultProps$props.autoFocus,
      preventDropOnDocument = _defaultProps$props.preventDropOnDocument,
      noClick = _defaultProps$props.noClick,
      noKeyboard = _defaultProps$props.noKeyboard,
      noDrag = _defaultProps$props.noDrag,
      noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling,
      onError = _defaultProps$props.onError,
      validator = _defaultProps$props.validator;

  var acceptAttr = React.useMemo(function () {
    return acceptPropAsAcceptAttr(accept);
  }, [accept]);
  var pickerTypes = React.useMemo(function () {
    return pickerOptionsFromAccept(accept);
  }, [accept]);
  var onFileDialogOpenCb = React.useMemo(function () {
    return typeof onFileDialogOpen === "function" ? onFileDialogOpen : noop;
  }, [onFileDialogOpen]);
  var onFileDialogCancelCb = React.useMemo(function () {
    return typeof onFileDialogCancel === "function" ? onFileDialogCancel : noop;
  }, [onFileDialogCancel]);
  /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */

  var rootRef = React.useRef(null);
  var inputRef = React.useRef(null);

  var _useReducer = React.useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive;
  var fsAccessApiWorksRef = React.useRef(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && canUseFileSystemAccessAPI()); // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (!fsAccessApiWorksRef.current && isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: "closeDialog"
            });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };

  React.useEffect(function () {
    window.addEventListener("focus", onWindowFocus, false);
    return function () {
      window.removeEventListener("focus", onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, fsAccessApiWorksRef]);
  var dragTargetsRef = React.useRef([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  React.useEffect(function () {
    if (preventDropOnDocument) {
      document.addEventListener("dragover", onDocumentDragOver, false);
      document.addEventListener("drop", onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener("dragover", onDocumentDragOver);
        document.removeEventListener("drop", onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]); // Auto focus the root when autoFocus is true

  React.useEffect(function () {
    if (!disabled && autoFocus && rootRef.current) {
      rootRef.current.focus();
    }

    return function () {};
  }, [rootRef, autoFocus, disabled]);
  var onErrCb = React.useCallback(function (e) {
    if (onError) {
      onError(e);
    } else {
      // Let the user know something's gone wrong if they haven't provided the onError cb.
      console.error(e);
    }
  }, [onError]);
  var onDragEnterCb = React.useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        var fileCount = files.length;
        var isDragAccept = fileCount > 0 && allFilesAccepted({
          files: files,
          accept: acceptAttr,
          minSize: minSize,
          maxSize: maxSize,
          multiple: multiple,
          maxFiles: maxFiles,
          validator: validator
        });
        var isDragReject = fileCount > 0 && !isDragAccept;
        dispatch({
          isDragAccept: isDragAccept,
          isDragReject: isDragReject,
          isDragActive: true,
          type: "setDraggedFiles"
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      }).catch(function (e) {
        return onErrCb(e);
      });
    }
  }, [getFilesFromEvent, onDragEnter, onErrCb, noDragEventsBubbling, acceptAttr, minSize, maxSize, multiple, maxFiles, validator]);
  var onDragOverCb = React.useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);

    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = "copy";
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (hasFiles && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = React.useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    }); // Make sure to remove a target present multiple times only once
    // (Firefox may fire dragenter/dragleave multiple times on the same element)

    var targetIdx = targets.indexOf(event.target);

    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }

    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      type: "setDraggedFiles",
      isDragActive: false,
      isDragAccept: false,
      isDragReject: false
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var setFiles = React.useCallback(function (files, event) {
    var acceptedFiles = [];
    var fileRejections = [];
    files.forEach(function (file) {
      var _fileAccepted = fileAccepted(file, acceptAttr),
          _fileAccepted2 = _slicedToArray(_fileAccepted, 2),
          accepted = _fileAccepted2[0],
          acceptError = _fileAccepted2[1];

      var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
          _fileMatchSize2 = _slicedToArray(_fileMatchSize, 2),
          sizeMatch = _fileMatchSize2[0],
          sizeError = _fileMatchSize2[1];

      var customErrors = validator ? validator(file) : null;

      if (accepted && sizeMatch && !customErrors) {
        acceptedFiles.push(file);
      } else {
        var errors = [acceptError, sizeError];

        if (customErrors) {
          errors = errors.concat(customErrors);
        }

        fileRejections.push({
          file: file,
          errors: errors.filter(function (e) {
            return e;
          })
        });
      }
    });

    if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
      // Reject everything and empty accepted files
      acceptedFiles.forEach(function (file) {
        fileRejections.push({
          file: file,
          errors: [TOO_MANY_FILES_REJECTION]
        });
      });
      acceptedFiles.splice(0);
    }

    dispatch({
      acceptedFiles: acceptedFiles,
      fileRejections: fileRejections,
      type: "setFiles"
    });

    if (onDrop) {
      onDrop(acceptedFiles, fileRejections, event);
    }

    if (fileRejections.length > 0 && onDropRejected) {
      onDropRejected(fileRejections, event);
    }

    if (acceptedFiles.length > 0 && onDropAccepted) {
      onDropAccepted(acceptedFiles, event);
    }
  }, [dispatch, multiple, acceptAttr, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]);
  var onDropCb = React.useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        setFiles(files, event);
      }).catch(function (e) {
        return onErrCb(e);
      });
    }

    dispatch({
      type: "reset"
    });
  }, [getFilesFromEvent, setFiles, onErrCb, noDragEventsBubbling]); // Fn for opening the file dialog programmatically

  var openFileDialog = React.useCallback(function () {
    // No point to use FS access APIs if context is not secure
    // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
    if (fsAccessApiWorksRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker

      var opts = {
        multiple: multiple,
        types: pickerTypes
      };
      window.showOpenFilePicker(opts).then(function (handles) {
        return getFilesFromEvent(handles);
      }).then(function (files) {
        setFiles(files, null);
        dispatch({
          type: "closeDialog"
        });
      }).catch(function (e) {
        // AbortError means the user canceled
        if (isAbort(e)) {
          onFileDialogCancelCb(e);
          dispatch({
            type: "closeDialog"
          });
        } else if (isSecurityError(e)) {
          fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
          // Try using the input

          if (inputRef.current) {
            inputRef.current.value = null;
            inputRef.current.click();
          } else {
            onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
          }
        } else {
          onErrCb(e);
        }
      });
      return;
    }

    if (inputRef.current) {
      dispatch({
        type: "openDialog"
      });
      onFileDialogOpenCb();
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, onErrCb, pickerTypes, multiple]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = React.useCallback(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, openFileDialog]); // Update focus state for the dropzone

  var onFocusCb = React.useCallback(function () {
    dispatch({
      type: "focus"
    });
  }, []);
  var onBlurCb = React.useCallback(function () {
    dispatch({
      type: "blur"
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = React.useCallback(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [noClick, openFileDialog]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = React.useMemo(function () {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey,
          role = _ref2.role,
          onKeyDown = _ref2.onKeyDown,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          onClick = _ref2.onClick,
          onDragEnter = _ref2.onDragEnter,
          onDragOver = _ref2.onDragOver,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          rest = _objectWithoutProperties(_ref2, _excluded3);

      return _objectSpread(_objectSpread(_defineProperty({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb)),
        role: typeof role === "string" && role !== "" ? role : "presentation"
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = React.useCallback(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = React.useMemo(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey,
          onChange = _ref3.onChange,
          onClick = _ref3.onClick,
          rest = _objectWithoutProperties(_ref3, _excluded4);

      var inputProps = _defineProperty({
        accept: acceptAttr,
        multiple: multiple,
        type: "file",
        style: {
          display: "none"
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        tabIndex: -1
      }, refKey, inputRef);

      return _objectSpread(_objectSpread({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  return _objectSpread(_objectSpread({}, state), {}, {
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case "focus":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: true
      });

    case "blur":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: false
      });

    case "openDialog":
      return _objectSpread(_objectSpread({}, initialState), {}, {
        isFileDialogActive: true
      });

    case "closeDialog":
      return _objectSpread(_objectSpread({}, state), {}, {
        isFileDialogActive: false
      });

    case "setDraggedFiles":
      return _objectSpread(_objectSpread({}, state), {}, {
        isDragActive: action.isDragActive,
        isDragAccept: action.isDragAccept,
        isDragReject: action.isDragReject
      });

    case "setFiles":
      return _objectSpread(_objectSpread({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });

    case "reset":
      return _objectSpread({}, initialState);

    default:
      return state;
  }
}

function noop() {}

const getIconByFileType = (type) => {
    switch (type) {
        case 'image/jpeg':
        case 'image/png':
        case 'image/gif':
        case 'image/bmp':
            return ImageIcon;
        case 'application/pdf':
            return PDFIcon;
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return ExcelIcon;
        case 'text/csv':
            return CSVIcon;
        default:
            return FileDescriptionIcon;
    }
};
const getIsIncorrectFileType = ({ file, requiredFileType, }) => {
    return Array.isArray(requiredFileType)
        ? !requiredFileType.includes(file.type)
        : file.type !== requiredFileType;
};
const getRequiredFileTypeError = ({ errorFiles, requiredFileType, }) => {
    let errorMessage = null;
    if (errorFiles.length > 0) {
        // todo: replace when react-intl is updated in FE
        // const errorMessage = Array.isArray(requiredFileType)
        //   ? intl.formatMessage(messages.invalidFileType, {
        //     fileTypes: requiredFileType.join(', '),
        //   })
        //   : intl.formatMessage(messages.invalidFileTypeSingle, {
        //     fileType: requiredFileType,
        //   })
        let readableRequiredFileType = '';
        if (Array.isArray(requiredFileType)) {
            const requiredFileTypeArray = requiredFileType.map((fileType) => fileType.split('/')[1]);
            // If there are more than 2 file types, join all but the last with a comma
            if (requiredFileTypeArray.length > 2) {
                readableRequiredFileType =
                    requiredFileTypeArray.slice(0, -1).join(', ') +
                        ', or ' +
                        requiredFileTypeArray.slice(-1);
            }
            else {
                readableRequiredFileType = requiredFileTypeArray.join(' or ');
            }
        }
        else {
            readableRequiredFileType = requiredFileType.split('/')[1];
        }
        errorMessage = {
            title: Array.isArray(requiredFileType)
                ? `Invalid file types. Please upload a file of type ${readableRequiredFileType}.`
                : `Invalid file type. Please upload a ${readableRequiredFileType} file.`,
        };
    }
    return errorMessage;
};
const kbToMb = (kb) => Math.round(kb / 1024);
const getMaxFileSizeError = ({ errorFiles, maxFileSizeInMB, }) => {
    let errorMessage = null;
    if (errorFiles.length > 0) {
        const hasMultiple = errorFiles.length > 1;
        let readableWrongFileSizeNames = [];
        if (hasMultiple) {
            readableWrongFileSizeNames = errorFiles.map((file) => `${file.name} (${kbToMb(file.size)} MB)`);
        }
        else {
            readableWrongFileSizeNames = [
                `${errorFiles[0].name} (${kbToMb(errorFiles[0].size)} MB)`,
            ];
        }
        errorMessage = {
            title: `File size${hasMultiple ? 's' : ''} exceed${hasMultiple ? '' : 's'} the limit of ${maxFileSizeInMB} MB.`,
            items: readableWrongFileSizeNames,
        };
    }
    return errorMessage;
};
const getIsIncorrectFileSize = (fileSize, maxFileSizeInMB) => {
    return kbToMb(fileSize) >= maxFileSizeInMB;
};

const useFileUploader = ({ initialFiles = [], multiple, onChange, requiredFileType, maxFileSizeInMB, }) => {
    // const intl = useIntl()
    const isMounted = index.useIsMounted();
    const [files, setFiles] = React.useState(initialFiles);
    const [errors, setErrors] = React.useState([]);
    React.useEffect(() => {
        if (isMounted) {
            onChange(multiple ? files : files[0]);
        }
    }, [files, onChange, isMounted, multiple]);
    const onDrop = React.useCallback((fileList) => {
        const acceptedFiles = [];
        const filesWithFileTypeErrors = [];
        const filesWithFileSizeErrors = [];
        const errorsArray = [];
        if (errors.length) {
            setErrors([]); // Reset the error when new files are dropped.
        }
        // Check file type
        if ((requiredFileType === null || requiredFileType === void 0 ? void 0 : requiredFileType.length) || maxFileSizeInMB) {
            // Here we're checking that the file types are correct
            fileList.forEach((file) => {
                const isIncorrectFileType = (requiredFileType === null || requiredFileType === void 0 ? void 0 : requiredFileType.length)
                    ? getIsIncorrectFileType({ file, requiredFileType })
                    : false;
                const isIncorrectFileSize = maxFileSizeInMB
                    ? getIsIncorrectFileSize(file.size, maxFileSizeInMB)
                    : false;
                if (isIncorrectFileType) {
                    filesWithFileTypeErrors.push(file);
                }
                if (isIncorrectFileSize) {
                    filesWithFileSizeErrors.push(file);
                }
                if (!isIncorrectFileType && !isIncorrectFileSize) {
                    acceptedFiles.push(file);
                }
            });
            const fileTypeErrorMessage = requiredFileType
                ? getRequiredFileTypeError({
                    errorFiles: filesWithFileTypeErrors,
                    requiredFileType,
                })
                : null;
            const maxSizeErrorMessage = maxFileSizeInMB
                ? getMaxFileSizeError({
                    errorFiles: filesWithFileSizeErrors,
                    maxFileSizeInMB,
                })
                : null;
            if (fileTypeErrorMessage) {
                errorsArray.push(fileTypeErrorMessage);
            }
            if (maxSizeErrorMessage) {
                errorsArray.push(maxSizeErrorMessage);
            }
        }
        else {
            acceptedFiles.push(...fileList);
        }
        if (errorsArray.length) {
            setErrors(errorsArray);
        }
        if (acceptedFiles.length) {
            // If multiple is false, only accept the first file
            const newFiles = multiple
                ? [...files, ...acceptedFiles]
                : [acceptedFiles[0]];
            setFiles(newFiles);
        }
    }, [errors.length, files, maxFileSizeInMB, multiple, requiredFileType]);
    const onFileChange = (InputEvent) => {
        const { files } = InputEvent.target;
        const fileList = Array.from(files !== null && files !== void 0 ? files : []).map((file) => Object.assign(file, {
            preview: URL.createObjectURL(file),
        }));
        onDrop(fileList);
    };
    const disabled = !multiple && files.length > 0;
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        // Disable if multiple is false and a file has been uploaded
        disabled,
    });
    const removeFile = (index) => {
        setFiles((prev) => [...prev.filter((_, i) => i !== index)]);
    };
    return {
        disabled,
        getRootProps,
        getInputProps,
        isDragActive,
        files,
        removeFile,
        onFileChange,
        errors,
    };
};

const defaultProps = {
    title: 'Title',
    subtitle: 'Subtitle',
    message: 'Message',
    status: 'info',
    variant: 'simple',
};

const Banner = ({ MessageTypographyProps, SubtitleTypographyProps, TitleTypographyProps, message, status, subtitle, sx, title, variant, }) => {
    return (React.createElement(index.ThemeProvider, { theme: index.theme },
        React.createElement(index.Box, { sx: Object.assign({ p: { simple: '8px 16px', detailed: 4 }[variant], boxSizing: 'border-box', minWidth: 300, maxWidth: 'fit-content', borderRadius: { simple: 2, detailed: 4 }[variant], borderWidth: 1, borderStyle: {
                    info: undefined,
                    error: { detailed: 'solid', simple: undefined }[variant],
                    warning: undefined,
                    success: undefined,
                }[status], backgroundColor: {
                    info: 'secondary.lightAlt',
                    error: 'error.lighter',
                    warning: 'warning.lighter',
                    success: undefined,
                }[status], borderColor: {
                    info: undefined,
                    error: 'error.main',
                    warning: undefined,
                    success: undefined,
                }[status] }, sx) },
            (variant === 'simple' || undefined) && (React.createElement(index.Typography, Object.assign({}, MessageTypographyProps, { variant: 'bodySmall' }), message)),
            variant === 'detailed' && (React.createElement(index.Stack, { spacing: 1 },
                React.createElement(index.Typography, Object.assign({}, TitleTypographyProps, { variant: 'labelLarge', component: 'li', color: {
                        info: undefined,
                        error: 'error.main',
                        warning: undefined,
                        success: undefined,
                    }[status], marginLeft: 1, sx: {
                        '::marker': {
                            color: {
                                error: 'error.main',
                                info: undefined,
                                warning: 'warning.main',
                                success: undefined,
                            }[status],
                        },
                    } }), title),
                React.createElement(index.Typography, Object.assign({}, SubtitleTypographyProps, { variant: 'bodyMedium', display: 'block' }), subtitle),
                React.createElement(index.Typography, Object.assign({}, MessageTypographyProps, { variant: 'bodySmall' }), message))))));
};
Banner.defaultProps = defaultProps;

const FileUploaderErrorList = ({ sx, items, }) => {
    return (React.createElement(index.List, { dense: true, sx: Object.assign({ listStyle: 'disc', paddingY: 1, paddingLeft: 2, textAlign: 'left' }, sx) }, items.map((item) => (React.createElement(index.Typography, { key: item, variant: 'caption', component: 'li', color: 'text.primary' }, item)))));
};

const FileList = ({ errors, files, removeFile, themeName }) => {
    const isFortressTheme = themeName === 'Fortress';
    return (React.createElement(index.List, { dense: true, sx: { overflow: 'hidden' } },
        !isFortressTheme && (React.createElement(index.Collapse, { in: Boolean(errors.length) }, errors.map(({ title, items }) => (React.createElement(Banner, { key: title, sx: { maxWidth: '100%', mb: 1 }, message: React.createElement(React.Fragment, null,
                title,
                (items === null || items === void 0 ? void 0 : items.length) && React.createElement(FileUploaderErrorList, { items: items })), status: 'error', variant: 'simple' }))))),
        React.createElement(index.TransitionGroup, null, files.map((file, i) => {
            const FileIcon = getIconByFileType(file.type);
            const zIndex = files.length - i;
            return (React.createElement(index.Slide, { key: file.name },
                React.createElement("div", null,
                    React.createElement(index.ListItem, { key: file.name, title: file.name, sx: {
                            backgroundColor: 'common.white',
                            position: 'relative',
                            zIndex,
                            border: '1px solid',
                            borderColor: 'divider',
                            borderRadius: 2,
                            marginBottom: 1,
                            alignItems: 'center',
                        } },
                        React.createElement(index.ListItemIcon, { sx: { margin: 0 } },
                            React.createElement(FileIcon, { color: isFortressTheme ? undefined : 'primary', fontSize: isFortressTheme ? 'medium' : 'large' })),
                        React.createElement(index.ListItemText, { primaryTypographyProps: {
                                sx: {
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    marginRight: '38px',
                                },
                            }, secondaryTypographyProps: Object.assign({}, (!isFortressTheme && {
                                variant: 'bodySmall',
                                color: 'text.secondary',
                            })), primary: file.name }),
                        React.createElement(index.ListItemSecondaryAction, { sx: {
                                zIndex,
                                color: 'action.active',
                            } },
                            React.createElement(index.IconButton, { edge: "end", onClick: () => removeFile(i) },
                                React.createElement(index.CloseIcon, null)))))));
        }))));
};

const Errors = ({ errors }) => {
    return (React.createElement(index.Collapse, { in: Boolean(errors.length) }, errors.map(({ title, items }) => (React.createElement(React.Fragment, { key: title },
        title,
        (items === null || items === void 0 ? void 0 : items.length) && (React.createElement(FileUploaderErrorList, { sx: {
                width: 200,
            }, items: items })))))));
};
const FortressFileBrowserErrors = ({ errors, files, isDragActive, multiple, }) => {
    return (React.createElement(index.Typography, { variant: 'bodySmall', marginTop: 11, align: 'center', color: errors.length ? 'error' : undefined }, isDragActive ? (multiple ? ('Drop files here...') : ('Drop a file here...')) : multiple ? (errors.length ? (React.createElement(Errors, { key: 1, errors: errors })) : ('Drag and drop files here, or click to select files')) : files.length > 0 ? ('You have added a file') : errors.length ? (React.createElement(Errors, { key: 2, errors: errors })) : ('Drag and drop a file here, or click to select a file')));
};

const FortressFileBrowser = React.forwardRef(({ disabled, errors, files, getInputProps, getRootProps, isDragActive, multiple, }, ref) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(index.Box, { sx: {
                borderRadius: '50%',
                backgroundColor: disabled
                    ? 'action.disabledBackground'
                    : 'primary.lighter',
                height: 48,
                width: 48,
                padding: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'absolute',
                left: 'calc(50% - 28px)',
                top: 28,
                zIndex: 0,
            } },
            React.createElement(index.Fade, { in: disabled, timeout: 300 },
                React.createElement("div", { style: { position: 'absolute', display: 'flex' } },
                    React.createElement(index.CheckIcon, { color: 'primary', fill: 'primary.light', fontSize: 'large' }))),
            React.createElement(index.Fade, { in: !disabled && isDragActive, timeout: 300 },
                React.createElement("div", { style: { position: 'absolute' } },
                    React.createElement(FolderOpenIcon, { color: 'primary', fill: 'primary.light', fontSize: 'large' }))),
            React.createElement(index.Fade, { in: !disabled && !isDragActive, timeout: 300 },
                React.createElement("div", { style: { position: 'absolute' } },
                    React.createElement(index.FolderIcon, { color: 'primary', fill: 'primary.light', fontSize: 'large' }))),
            React.createElement(AddIcon, { fontSize: 'small', color: 'primary', sx: {
                    display: disabled ? 'none' : 'block',
                    backgroundColor: 'common.white',
                    position: 'absolute',
                    borderRadius: '50%',
                    bottom: 8,
                    right: 8,
                } })),
        React.createElement(index.ButtonBase, Object.assign({}, getRootProps(), { disabled: disabled, sx: {
                backgroundColor: disabled ? 'transparent !important' : undefined,
                borderRadius: 4,
                border: `1px ${isDragActive ? 'solid' : 'dashed'}`,
                borderColor: disabled ? 'action.disabled' : 'primary.light',
                transition: ({ transitions }) => transitions.create('border'),
                padding: 2,
                width: '100%',
                position: 'relative',
                zIndex: 1,
            } }),
            React.createElement("input", Object.assign({ ref: ref }, getInputProps(), { multiple: multiple })),
            React.createElement(FortressFileBrowserErrors, { errors: errors, files: files, isDragActive: isDragActive, multiple: multiple }))));
});
FortressFileBrowser.displayName = 'FortressFileBrowser';

const PortalFileBrowser = ({ disabled, onFileChange, multiple }) => {
    const browseInputRef = React.useRef(null); // Reference for the hidden "browse" file input
    const cameraInputRef = React.useRef(null); // Reference for the hidden "camera" file input
    const handleBrowseClick = () => {
        if (browseInputRef.current) {
            browseInputRef.current.click();
        }
    };
    const handleCameraClick = () => {
        if (cameraInputRef.current) {
            cameraInputRef.current.click();
        }
    };
    const buttonSX = {
        margin: 'unset !important',
        display: 'block',
        backgroundColor: disabled ? 'transparent !important' : undefined,
        borderRadius: 4,
        borderWidth: 1,
        borderStyle: 'dashed',
        borderColor: disabled ? 'action.disabled' : 'primary.main',
        transition: ({ transitions }) => transitions.create(['border-color', 'border-style']),
        padding: 2,
        mb: 1,
        width: 'calc(50% - 4px)',
        position: 'relative',
        zIndex: 1,
        '&:hover': {
            borderStyle: 'solid',
        },
    };
    const boxSX = {
        height: 64,
        width: 64,
        margin: 'auto',
        borderRadius: '50%',
        backgroundColor: 'action.hover',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mb: 2,
    };
    const inputProps = {
        type: 'file',
        onChange: onFileChange,
        multiple,
        style: { display: 'none' },
        tabIndex: -1,
    };
    return (React.createElement(index.Stack, { direction: 'row', spacing: 1, justifyContent: 'space-between' },
        React.createElement(ButtonBase, { disabled: disabled, sx: buttonSX, onClick: handleBrowseClick },
            React.createElement("input", Object.assign({ ref: browseInputRef }, inputProps)),
            React.createElement(index.Box, { sx: boxSX },
                React.createElement(UploadIcon, { fontSize: 'large' })),
            React.createElement(index.Typography, { display: 'block', variant: 'bodySmall', color: 'text.secondary', align: 'center' }, "Click to browse")),
        React.createElement(ButtonBase, { disabled: disabled, sx: buttonSX, onClick: handleCameraClick },
            React.createElement("input", Object.assign({ ref: cameraInputRef }, inputProps, { accept: "image/*", 
                // @ts-ignore
                capture: "camera" })),
            React.createElement(index.Box, { sx: boxSX },
                React.createElement(AddAPhotoIcon, { fontSize: 'large' })),
            React.createElement(index.Typography, { display: 'block', variant: 'bodySmall', color: 'text.secondary', align: 'center' }, "Take a Photo"))));
};
PortalFileBrowser.displayName = 'PortalFileBrowser';

const FileUploader = React.forwardRef(({ multiple, onChange, sx, requiredFileType, initialFiles, maxFileSizeInMB, }, ref) => {
    const [themeName] = index.useThemeName();
    const { disabled, getRootProps, getInputProps, isDragActive, files, onFileChange, removeFile, errors, } = useFileUploader({
        multiple,
        onChange,
        requiredFileType,
        initialFiles,
        maxFileSizeInMB,
    });
    return (React.createElement(index.Box, { sx: Object.assign({ position: 'relative', maxWidth: 300 }, sx) },
        themeName === 'Fortress' && (React.createElement(FortressFileBrowser, { ref: ref, disabled: disabled, errors: errors, files: files, getInputProps: getInputProps, getRootProps: getRootProps, isDragActive: isDragActive, multiple: multiple })),
        themeName === 'Portal' && (React.createElement(PortalFileBrowser, { disabled: disabled, onFileChange: onFileChange, multiple: multiple })),
        React.createElement(FileList, { files: files, errors: errors, removeFile: removeFile, themeName: themeName })));
});
FileUploader.displayName = 'FileUploader';
FileUploader.defaultProps = {
    multiple: false,
    onChange: () => { },
};

exports.default = FileUploader;
